import styled from 'styled-components';
import { rgba } from 'polished';
import colors from '../../constants/colors';

const VideoFrame = styled.div`
  aspect-ratio: 16 / 9;
  max-height: 100%;
  width: 100%;
`;

const PlayerFrame = styled(VideoFrame)`
  background-color: ${colors.main.black};

  mux-player {
    display: block;
    height: 100%;
    width: 100%;
  }

  /*
   * mux-player fits the poster with object-fit: contain, so anything that is not
   * 16:9 gets letter/pillar boxed while the player sits idle, then snaps to a
   * full frame on play. Fill the frame instead, the same way the video itself
   * does once it starts. Still needed now that posters come from the video's own
   * frame 0: the fallback paths are curated pictures that keep their own aspect
   * ratio, since the image service resizes with fit-in.
   */
  mux-player::part(poster) {
    object-fit: cover;
    object-position: center;
  }
`;

const PlaceholderPicture = styled.div`
  background-color: ${rgba(colors.main.black, 0.1)};
  background-size: cover;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  border-radius: 0px;
  margin: 0 auto;
  height: 100%;
  width: 100%;
  min-height: 176px;
`;

export { PlayerFrame, PlaceholderPicture };
export default VideoFrame;
